module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('el-dialog', {
    attrs: {
      "id": "login",
      "customClass": "customWidth",
      "show-close": false,
      "title": "Login",
      "visible": _vm.dialogVisible,
      "size": "tiny",
      "visible": "false"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "account-box"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('a', {
    staticClass: "pull-right label-forgot",
    attrs: {
      "href": "#/forgotEmail"
    }
  }, [_vm._v("Forgot email?")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "inputUsernameEmail"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputUsernameEmail"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('a', {
    staticClass: "pull-right label-forgot",
    attrs: {
      "href": "#/forgotPassword"
    }
  }, [_vm._v("Forgot password?")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "inputPassword"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "checkbox pull-left"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v("Remember me")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn btn-primary pull-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.userLogin
    }
  }, [_vm._v("Log In")])]), _vm._v(" "), _c('a', {
    staticClass: "forgotLnk",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "or-box"
  }, [_c('center', [_c('span', {
    staticClass: "text-center login-with"
  }, [_vm._v("Login or "), _c('b', [_c('a', {
    attrs: {
      "href": "#/signup"
    }
  }, [_vm._v("Sign Up")])])])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 row-block"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "href": "#/signup"
    }
  }, [_vm._v("Create New Account")])])])])])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b8a456dc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 1322
// module chunks = 2